import { updateHistoryStackAfterErase } from '../../utils/undoRedoUtils.js'

export const handleEraseUp = (state) => {
  const {
    boardId,
    ////////
    paths,
    erasedPathKeys,
    setIsErasingActive,
    previousErasePoint,
    historyStack,
    setHistoryStack,
    // 동시편집
    ydocRef,
    yPathsRef,
  } = state

  /**
   * eraser follower 숨기기 및 상태 초기화
   */
  document.getElementById('eraser').style.display = 'none'
  setIsErasingActive(false)
  previousErasePoint.current = { x: 0, y: 0 }

  /**
   * erase 종료 조건
   */
  // 종료조건) 아무것도 지워지지 않았으면 종료
  if (!erasedPathKeys.current.length) return
  // 종료조건) 실제로 존재하는 pathKey만 필터링 -> 아무것도 유효하지 않으면 종료
  const validErasedKeys = erasedPathKeys.current.filter((key) => key in paths)
  if (!validErasedKeys.length) {
    erasedPathKeys.current = []
    return
  }

  let eraseStack = {
    type: 'erase',
    pathKeys: validErasedKeys,
    pathData: Object.fromEntries(validErasedKeys.map((k) => [k, paths[k]])),
  }

  /**
   * 지우기 선택된 path 삭제, 지우기 완료 후 zIndex 재정렬
   */
  const remainingPaths = Object.entries(paths).filter(([key]) => !validErasedKeys.includes(key))

  ydocRef.current.transact(() => {
    // for (let pathKey of validErasedKeys) {
    //   yPathsRef.current.delete(pathKey) // [동시편집 - 삭제]
    // }
    // 삭제
    validErasedKeys.forEach((key) => yPathsRef.current.delete(key))

    // updatedPathsRef.current.forEach((value, key) => {
    //   yPathsRef.current.set(key, value)
    // })
    // updatedPathsRef.current.clear()
    // zIndex 재정렬
    let newZIndex = 0
    remainingPaths.forEach(([key, path]) => {
      const yPath = yPathsRef.current.get(key)
      if (yPath) {
        yPath.set('zIndex', newZIndex)
        newZIndex++
      }
    })
  })

  /**
   * 상태 정리
   */
  erasedPathKeys.current = []
  // [undo/redo] 히스토리 스택에 기록
  updateHistoryStackAfterErase({ boardId, eraseStack, historyStack, setHistoryStack })
}
